var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWashingMachine = function SvgWashingMachine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 18,
    x: 1.5,
    y: 0.5,
    stroke: "currentColor",
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    x: 5.5,
    y: 6.5,
    stroke: "currentColor",
    rx: 4.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 1,
    x: 11.5,
    y: 3,
    fill: "currentColor",
    rx: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 3.5,
    y: 2.5,
    fill: "currentColor",
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 12c.5-.667 1.868-2.224 3.5-1 2 1.5 3.5 0 4.5-1.5"
  })));
};
export default SvgWashingMachine;